import RecipeDetail from './RecipeDetail';
export default RecipeDetail;
